import { render, staticRenderFns } from "./FormResultDataView.vue?vue&type=template&id=99729c98&scoped=true"
import script from "./FormResultDataView.vue?vue&type=script&lang=js"
export * from "./FormResultDataView.vue?vue&type=script&lang=js"
import style0 from "./FormResultDataView.vue?vue&type=style&index=0&id=99729c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99729c98",
  null
  
)

export default component.exports